import { ITranslations } from '@model';

import { ITranslationResponse } from './model';

export const transformTranslations = (translations: ITranslationResponse[]): ITranslations =>
  translations.reduce((finalTranslation: ITranslations, translation) => {
    finalTranslation[translation.key] = translation.text;
    return finalTranslation;
  }, {});
